import { createAction, props } from "@ngrx/store";
import { RecursivePartial } from "../recursive-partial";
import {UserProfileState} from './user-profile.state';

export const ExtendStateAction = createAction(
  "[UserProfile Action] Extend State",
  props<{ newState: Partial<UserProfileState> }>(),
);

export const MergeStateAction = createAction(
  "[UserProfile Action] Merge State",
  props<{ newState: RecursivePartial<UserProfileState> }>(),
);

export const InitializeAction = createAction(
  "[UserProfile Action] Initialize Action"
);


